import { lazy } from 'react'
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';
import { WEBHRIS_OLD_DASHBOARD_URL } from '../../../config/settings';
// import LoginScreen from './LoginScreen'

export const LOGIN_ROUTE = "/login";

const LoginScreen = lazy(() => 
    import(/* webpackChunkName: "loginScreen" */ './LoginScreen').then(async module => {
       return module
    })
);

export const routes = [
    {
        path: LOGIN_ROUTE,
        component: LoginScreen,
        exact: true,
        public: true
    }
];
